// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"ProfileDropdown__dropdown___qTbjP"};